'use client'

import {
  Body,
  Container,
  GlassCard,
  Reveal,
  Section,
  SectionHeader,
  Stagger,
} from 'design-studio'
import { DiagramModelArtifacts } from '@/components/diagrams/diagram-model-artifacts'
import { SL_GLASS_SURFACE } from '@/components/theme'

export function SectionRegulated() {
  return (
    <Section
      id="regulated"
      className="relative scroll-mt-19 bg-zinc-200 py-16 backdrop-blur-md sm:py-24 dark:bg-slate-800/10"
    >
      <Container className="relative z-10 max-w-6xl">
        <Stagger className="space-y-10">
          <Reveal>
            <SectionHeader
              pretitle="Enterprise and regulated environments"
              pretitleColor="text-teal-500"
              title="Built for Controlled Change, Compliance, and Safety-Critical Delivery"
              description="The techniques behind SpecLogician come from years of applying mathematical modeling and automated reasoning in large, heavily regulated organizations."
            />
          </Reveal>

          <Reveal className="grid gap-8 lg:grid-cols-[1fr_1.05fr]">
            <div>
              <Body size="sm" tone="muted">
                These are environments where teams need to deliver
                safety-critical software with confidence, support audit and
                governance, reason precisely about policy and edge cases, and
                extract actionable intelligence from complex software behavior.
              </Body>
              <Body size="sm" tone="muted" className="mt-4">
                Because the model can be refined using logs, traces, and
                operational evidence, SpecLogician helps teams connect formal
                reasoning with what the system is actually doing in production.
              </Body>
              <Body size="sm" tone="muted" className="mt-4">
                SpecLogician brings that proven discipline into an LLM-powered
                workflow. This is not a new process invented for AI coding — it
                is the operationalization of years of logic-first engineering
                practice into a system that AI agents can participate in.
              </Body>
            </div>

            <GlassCard
              className={`overflow-hidden lg:p-12 ${SL_GLASS_SURFACE}`}
            >
              <DiagramModelArtifacts
                surfaceClassName="text-[#EDEFF6] dark:text-[#1A2340]"
                centerSurfaceClassName="text-[#EDEFF6] dark:text-[#1A2340]"
              />
            </GlassCard>
          </Reveal>
        </Stagger>
      </Container>
    </Section>
  )
}
